
import { colors } from '@tempmee/tailwind';
import { CollapsibleRow } from '../CollapsibleRow/CollapsibleRow';
import { Title } from '../CollapsibleRow/Title';
import { Value } from '../CollapsibleRow/Value';
import { SolidHomeHouseIcon } from '@tempmee/react-icons';

export const OfficeRow = ({ value }) => (
  <CollapsibleRow
    disabled
    TitleComponent={() => <Title text="Office:" />}
    ValueComponent={() => (
      <Value
        customStyles={{
          color: colors.neutral[600],
        }}
        text={value}
      />
    )}
    icon={<SolidHomeHouseIcon size={24} color={colors.secondary[500]} />}
  />
);
